import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon, Input, Dropdown } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment'

import { getCategorizedTags, createTag } from '../actions/tags'
import { getTagMatrix, exportToExcel, updateTag } from '../actions/v2_tags'
import * as tagsConstants from '../constants/tags'
import * as traineesConstants from '../constants/trainees'
import * as traineesActions from '../actions/trainees'
import { createTrainingRequirement, updateTrainingRequirement } from '../actions/training_requirements'

import MatrixTable from './components/tables/matrix_table'
import TraineeModal from './components/modals/trainee_modal';
import ModalDuplicateTraineeWarning from './components/modals/duplicate_trainee_warning'
import UpdateTagsModal from './components/modals/update_tags'
import TraineesTable from './components/tables/v2_trainees_table'
import ConfirmationModal from './components/modals/confirmation_modal';
import TagFormModal from './components/modals/training_matrix_modal'
import AppComponent from './components/app_component'
import ElementLoader from './components/element_loader';

import withDefaultRoleOptions from './components/with_default_role_options';
import { debounce, validateTrainee } from '../helpers';

class Trainees extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      trainingMatrix: [],
      trainingModules: [],
      showAddTraineeForm: false,
      showUpdateTagsModal: false,
      showMatrixView: false,
      showDuplicateTraineeWarning: false,
      duplicateTraineeMethod: '',
      showAddDuplicateTraineeConfirmation: false,
      showUpdateDuplicateTraineeConfirmation: false,
      selectedRow: {},
      trainee: {},
      trainees: [],
      filterOptions: {
        id: '',
        tag_name: '',
        search_term: '',
        include_archived_trainees: false,
        context: 'tags',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        page: 1,
        per_page: 25
      },
      allTags: [ { key: 'All Trainees', text: 'All Trainees', value: '' } ],
      mode: '',
      renderTraineesTable: true,
      isRegion: false,
      regions: [],
      tags: [],
      traineeFirstName: '',
      traineeLastName: '',
      traineeEmail: '',
      showTagForm: false,
      tagFormMode: 'create',
      roleOptions: [ { key: 'All Roles', text: 'All Roles', value: '' } ],
      roleFilter: ''
    }
  
  }

  componentDidMount() {
    this.props.getCategorizedTags();
    this.getTrainees()
  }

  componentWillReceiveProps(nextProps){
    this.handleV2TagsNextProps(nextProps)
    this.handleTagsNextProps(nextProps)
    this.handleTraineesNextProps(nextProps)
    this.handleRolesNextProps(nextProps)
  }

  handleTraineesNextProps = (nextProps) => {
    if (this.props.requestType === nextProps.requestType) return

    if (nextProps.requestSuccess){
      switch(nextProps.requestType){
        case traineesConstants.GET_TRAINEES_SUCCESS:
          this.handleGetTraineesNextProps(nextProps)
          break
        case traineesConstants.SHOW_DUPLICATE_TRAINEE_WARNING:
          this.setState({
            trainee: nextProps.trainee,
            duplicates: nextProps.duplicates,
            showDuplicateTraineeWarning: nextProps.showDuplicateTraineeWarning,
            duplicateTraineeMethod: nextProps.duplicateTraineeMethod
          })
          break;
        case traineesConstants.ADD_TRAINEE_SUCCESS:
        case traineesConstants.ADD_DUPLICATE_TRAINEE_SUCCESS:
        case traineesConstants.UPDATE_TRAINEE_SUCCESS:
        case traineesConstants.UPDATE_DUPLICATE_TRAINEE_SUCCESS:
        case traineesConstants.ARCHIVE_TRAINEE_SUCCESS:
        case traineesConstants.UNARCHIVE_TRAINEE_SUCCESS:
          this.refreshTraineesData();
          this.props.getAssignedRoles();
          break
        default: break
      }
      this.hideLoadingMessage()
    }
    else {
      this.showLoadingMessage()
    }
  }

  handleTagsNextProps = (nextProps) => {
    if (this.props.tagsRequestType === nextProps.tagsRequestType) return;
    const { tagsRequestType } = nextProps 

    if (tagsRequestType === tagsConstants.GET_CATEGORIZED_TAGS_SUCCESS) {
      this.setState({
        tags: nextProps.tags,
        regions: nextProps.regions,
        allTags: nextProps.allTags
      })
      this.hideLoadingMessage()

    }
    else if ([tagsConstants.CREATE_TAG_SUCCESS].includes(tagsRequestType)) {
      var { filterOptions } = this.state
      filterOptions.id = nextProps.tag.id
      filterOptions.tag_name = nextProps.tag.name
      this.setState({filterOptions})

      this.hideLoadingMessage()
      this.props.getCategorizedTags()
    }
    else {
      this.showLoadingMessage()
    }
  }

  handleGetTraineesNextProps = (nextProps) => {
    if (this.props.trainees !== nextProps.trainees) {
      let { trainees, filterOptions } = this.state;
      trainees = filterOptions.page == 1 ? nextProps.trainees : trainees.concat(nextProps.trainees)
      this.setState({ trainees }, this.refreshRoleOptions);
    }
  }

  handleV2TagsNextProps = (nextProps) => {
    if (this.props.v2tags.requestType === nextProps.v2tags.requestType) return
    if (!['GET_TAG_MATRIX_SUCCESS', 'UPDATE_TAG_SUCCESS'].includes(nextProps.v2tags.requestType)) return this.showLoadingMessage();

    var { id, name, training_matrix, training_modules } = nextProps.v2tags.tagMatrix
  
    const newState = {
      trainingMatrix: training_matrix,
      trainingModules: training_modules
    }

    if (nextProps.v2tags.requestType === 'UPDATE_TAG_SUCCESS') {
      const { filterOptions } = this.state;
      filterOptions.id = id;
      filterOptions.tag_name = name;
      newState.filterOptions = filterOptions;
    } else if (nextProps.v2tags.requestType === 'GET_TAG_MATRIX_SUCCESS') {
      this.props.getAssignedRoles();
    }

    this.setState(newState, ()=>{
      this.hideLoadingMessage();
      this.props.getCategorizedTags();
    })
  }

  handleRolesNextProps = (nextProps) => {
    if (this.props.assignedRoles === nextProps.assignedRoles || nextProps.isLoadingRoles) return;
    this.updateRoleOptions(nextProps.assignedRoles);
  }

  updateRoleOptions = (assignedRoles) => {
    let roleOptions = [ { key: 'All Roles', text: 'All Roles', value: '' } ];
    for (var i in assignedRoles) {
      const newRole = assignedRoles[i];
      const existingRoleOption = roleOptions.find((role) => { return role.text === newRole.name })
      if (existingRoleOption) continue;
      roleOptions.push({ key: newRole.name, text: newRole.name, value: newRole.name })
    }

    let roleFilter = this.state.roleFilter;

    if(!roleOptions.find(({ value }) => value === roleFilter)) {
      this.setState({ roleOptions, roleFilter: "" }, this.refreshTraineesData)
    } else {
      this.setState({ roleOptions })
    }
  }

  getRoleOptionsFromTrainees(trainees) {
    let roleOptions = []
    for (let trainee of trainees) {
      this.addFromTraineeRoles(roleOptions, trainee.role_list)
    }
    return roleOptions
  }

  addFromTraineeRoles(roleOptions, roles) {
    for (let role of roles) {
      const existingRoleOption = roleOptions.find((option) => { return option.text === role })
      if (existingRoleOption) continue;
      roleOptions.push({ key: role, text: role, value: role })
    }
  }

  updateRoleOptionsFromTrainees() {
    const { trainees } = this.state;
    let roleOptions = [ { key: 'All Roles', text: 'All Roles', value: '' } ];
    roleOptions = roleOptions.concat(this.getRoleOptionsFromTrainees(trainees))
    this.setState({ roleOptions })
  }

  refreshRoleOptions() {
    const { tag_name, search_term } = this.state.filterOptions;
    if (tag_name || search_term) {
      this.updateRoleOptionsFromTrainees();
    } else {
      this.props.getAssignedRoles();
    }
  }

  apiAddTrainee = (details) => {
    var params = {
      first_name: details.firstName,
      last_name: details.lastName,
      email: details.email,
    }

    if (this.state.filterOptions.tag_name.length > 0) {
      if (this.state.isRegion) {
        params.region_list = [this.state.filterOptions.tag_name]
      } else {
        params.tag_list = [this.state.filterOptions.tag_name]
      }
    }

    this.props.addTrainee(params)
  }

  apiAddTraineeWithValidation = (trainee) => {
    if (this.state.filterOptions.tag_name.length > 0) {
      if (this.state.isRegion) {
        trainee.region_list = [this.state.filterOptions.tag_name]
      } else {
        trainee.tag_list = [this.state.filterOptions.tag_name]
      }
    }

    this.props.addTraineeWithValidation(trainee)
  }

  apiAddDuplicateTrainee(details) {
    var params = {
      first_name: details.first_name,
      last_name: details.last_name,
      email: details.email,
    }

    if (this.state.filterOptions.tag_name.length > 0) {
      if (this.state.isRegion) {
        params.region_list = [this.state.filterOptions.tag_name]
      } else {
        params.tag_list = [this.state.filterOptions.tag_name]
      }
    }

    this.props.addDuplicateTrainee(params)
  }

  apiUpdateDuplicateTrainee(details) {
    var params = {
      id: details.id,
      first_name: details.first_name,
      last_name: details.last_name,
      email: details.email,
    }

    if (this.state.filterOptions.tag_name.length > 0) {
      if (this.state.isRegion) {
        params.region_list = [this.state.filterOptions.tag_name]
      } else {
        params.tag_list = [this.state.filterOptions.tag_name]
      }
    }

    this.props.updateDuplicateTrainee(params)
  }

  onAddDuplicateTrainee(details) {
    this.apiAddDuplicateTrainee(details)
    this.setState({ showAddDuplicateTraineeConfirmation: false, restrictUpdate: false })
  }

  onUpdateDuplicateTrainee(details) {
    this.apiUpdateDuplicateTrainee(details)
    this.setState({ showUpdateDuplicateTraineeConfirmation: false, restrictUpdate: false })
  }

  showTraineeForm = (showAddTraineeForm, row) => {
    this.setState({
      selectedRow: row,
      showAddTraineeForm: showAddTraineeForm
    }, ()=>{
      const { showAddTraineeForm } = this.state;
      if (!showAddTraineeForm) {
        this.refreshTraineesData()
      }
    })
  }

  showDuplicateTraineeWarningModal(showDuplicateTraineeWarning) {
    this.setState({
      showDuplicateTraineeWarning: showDuplicateTraineeWarning
    })
  }

  searchTrainee = (evt) => {
    var filterOptions = this.state.filterOptions
    filterOptions.search_term = evt.target.value
    filterOptions.context = this.state.isRegion ? 'regions' : 'tags'
    filterOptions.page = 1
    this.setState({
      filterOptions: filterOptions
    }, this.refreshTraineesData)
  }

  getTagId = (tag_name, allTags=this.state.allTags) => {
    var found_tag = allTags.find((tag) => { return tag.value === tag_name });
    return found_tag.id
  }

  onTagChange = (evt, obj) => {
    var { filterOptions, showMatrixView } = this.state
    if (showMatrixView && filterOptions.tag_name && obj.value === '') return;
    if (obj.value === filterOptions.tag_name) return;

    var isRegion = this.isInObjectArray(this.state.regions, obj.value)
    filterOptions.tag_name = obj.value
    filterOptions.context = isRegion ? 'regions' : 'tags'
    filterOptions.id = this.getTagId(obj.value)
    filterOptions.page = 1
  
    this.setState({ filterOptions, isRegion }, this.refreshTraineesData)
  }

  onRoleChange = (evt, obj) => {
    let { roleFilter, showMatrixView, filterOptions } = this.state;
    if (showMatrixView && roleFilter && obj.value === '' ) return;
    if (obj.value === roleFilter) return;
  
    filterOptions.page = 1
    this.setState({ roleFilter: obj.value, filterOptions }, this.refreshTraineesData)
  }

  getRoleId = (role) => {
    const { assignedRoles } = this.props;
    if (!assignedRoles) return;

    const roleMatch = assignedRoles.find((roleItem) => { return roleItem.name === role });
    return roleMatch && roleMatch.id
  }

  showMatrix = (showMatrixView) => {
    this.setState({ showMatrixView }, this.refreshTraineesData)
  }

  refreshTraineesData = () => {
    let { filterOptions, roleFilter, showMatrixView } = this.state;
    const requestOptions = {...filterOptions};
    requestOptions.role_name = roleFilter

    if (!showMatrixView) return this.debouncedGetTrainees(requestOptions);

    const { page, per_page, ...requestOptionsWithoutPaging } = requestOptions;

    if (!requestOptionsWithoutPaging.tag_name) {
      requestOptionsWithoutPaging.id = this.getRoleId(roleFilter)
      requestOptionsWithoutPaging.tag_name = roleFilter
      requestOptionsWithoutPaging.context = 'roles'
    }

    this.props.getMatrix(requestOptionsWithoutPaging);
  }

  getTrainees = () => {
    let { filterOptions, roleFilter } = this.state;
    const requestOptions = {...filterOptions};
    requestOptions.role_name = roleFilter
    this.props.getTrainees(requestOptions)
  }

  debouncedGetTrainees = (requestOptions) => {
    debounce(this.props.getTrainees, 1000)(requestOptions)
  }

  setNewPage = () => {
    const { filterOptions } = this.state;

    if (this.props.trainees.length < filterOptions.per_page) return;

    this.setState({
      filterOptions: { ...filterOptions, page: filterOptions.page + 1 }
    }, this.getTrainees)
  }

  exportToExcel = (evt) => {
    this.setState({
      isExporting: true
    })

    const { filterOptions, roleFilter } = this.state;
    const requestOptions = {...filterOptions};
    requestOptions.role_name = roleFilter

    if (!requestOptions.tag_name) {
      requestOptions.id = this.getRoleId(roleFilter)
      requestOptions.tag_name = roleFilter
      requestOptions.context = 'roles'
    }

    this.props.exportToExcel(requestOptions).then((response)=>{
      var suffix = requestOptions.tag_name.length > 0 ? requestOptions.tag_name : 'All Trainees'
      var filename =  `${suffix}_${moment(new Date()).format("YYYY-MMM-DD")}.xlsx`
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.setState({
        isExporting: false
      })
    })
  }

  updateTags = (params) => {
    this.props.updateTrainee(params).then((response)=>{
      this.refreshTraineesData()
    })
  }

  clearFilters = (evt) => {
    var { filterOptions} = this.state
    filterOptions.search_term = ''
    filterOptions.tag_name = ''
    filterOptions.page = 1;
    this.setState({ filterOptions, roleFilter: '' }, () => this.props.getTrainees(filterOptions))
  }

  toggleArchived = (evt) => {
    var { filterOptions} = this.state
    filterOptions.include_archived_trainees = !filterOptions.include_archived_trainees;
    filterOptions.page = 1;
    this.setState({ filterOptions }, this.refreshTraineesData)
  }

  updateTraineeWithValidation = (details) => {
    var params = {
      id: details.id,
      first_name: details.first_name,
      last_name: details.last_name,
      email: details.email,
      role_list: details.role_list
    }
    this.props.updateTraineeWithValidation(params)
  }

  setSelectedRow = (selectedRow) => {
    this.setState({selectedRow})
  }

  showArchiveModal = (evt) => {
    this.setState({
      showArchiveModal: true
    })
  }

  archiveTrainee = (traineeId) => {
    this.setState({
      showArchiveModal: false
    })
    this.props.archiveTrainee(traineeId)
  }

  showUnarchiveModal = (evt) => {
    this.setState({
      showUnarchiveModal: true
    })
  }

  unarchiveTrainee = (traineeId) => {
    this.setState({
      showUnarchiveModal: false
    })
    this.props.unarchiveTrainee(traineeId)
  }

  dupliteTraineeWarningCallback = () => {
    this.showDuplicateTraineeWarningModal(false)
    switch(this.state.duplicateTraineeMethod) {
      case 'add':
        this.setState({ showAddDuplicateTraineeConfirmation: true })
        break;
      case 'update':
        this.setState({ showUpdateDuplicateTraineeConfirmation: true })
        break;
      default:
        break;
    }
  }

  toggleTagForm = (show) => {
    this.setState({ showTagForm: show })
    if(!show) this.refreshTraineesData();
  }

  createNewTag = (evt) => {
    this.setState({
      showTagForm: true,
      tagFormMode: 'create'
    })
  }

  onCreateTag = (tag) => {
    this.props.createTag(tag);

    var { filterOptions } = this.state
    filterOptions.tag_name = tag.tag_name
    this.setState({ 
      filterOptions,
      showTagForm: false,
    })
  }

  updateTag = (evt) => {
    var { filterOptions, trainees } = this.state
    filterOptions.trainees_ids = trainees.map((trainee)=>{return trainee.id})
    this.setState({
      showTagForm: true,
      tagFormMode: 'update',
      filterOptions
    })
  }

  onUpdateTag = (tag) => {
    this.props.updateTag(tag);

    var { filterOptions } = this.state
    filterOptions.tag_name = tag.tag_name
    this.setState({ 
      filterOptions,
      showTagForm: false,
    })
  }

  updateTrainingRequirement = (details) => {
    if (details.id) {
      this.props.updateTrainingRequirement(details)
    }
    else {
      this.props.createTrainingRequirement(details)
    }
  }

  render() {
    const { trainingMatrix, trainingModules, showAddTraineeForm, showUpdateTagsModal, showDuplicateTraineeWarning, showAddDuplicateTraineeConfirmation, showUpdateDuplicateTraineeConfirmation, showArchiveModal, showUnarchiveModal,
            showTagForm, tagFormMode, filterOptions, selectedRow: trainee } = this.state;
    const errors = validateTrainee(trainee);
    const errorList= Object.values(errors).filter((e) => e);
    const hasInvalidDetails = errorList.length > 0;

    return (
      <div className='training-matrix'>
        {
          showTagForm &&
          <TagFormModal
            onCreate={this.onCreateTag}
            onUpdate={this.onUpdateTag}
            onClose={ (evt) => this.toggleTagForm(false) }
            tag={filterOptions}
            mode={tagFormMode}
            context='tags'
            parentName='Trainees'
          />
        }
        {
          showAddTraineeForm &&
          <TraineeModal
            selectedTrainee={this.state.selectedRow}
            createTrainee={ this.apiAddTraineeWithValidation }
            updateTrainee={ this.updateTraineeWithValidation }
            onClose={ () => this.showTraineeForm(false, {}) }
          />
        }
        {
          showDuplicateTraineeWarning &&
          <ModalDuplicateTraineeWarning
            trainee={this.state.trainee}
            duplicates={this.state.duplicates}
            show={ showDuplicateTraineeWarning }
            positiveCallback = { () => this.dupliteTraineeWarningCallback() }
            onClose={ () => {
              this.showDuplicateTraineeWarningModal(false)
              this.refreshTraineesData()
              }
            }
          />
        }
        {
          showAddDuplicateTraineeConfirmation &&
          <ConfirmationModal
            show={ showAddDuplicateTraineeConfirmation }
            size = 'mini'
            title = 'Add Duplicate Trainee'
            message = {["Are you sure you want to add a ", <strong>Duplicate Trainee</strong>,  "?", <br/>, "This is likely to cause confusion and take time to rectify."]}
            positiveLabel = 'Add Duplicate'
            negativeLabel = 'Cancel'
            positiveButtonStyle = "red"
            negativeButtonStyle = "green"
            positiveCallback = { () => this.onAddDuplicateTrainee(this.props.trainee) }
            negativeCallback = { () => {
              this.refreshTraineesData()
              this.setState({ showAddDuplicateTraineeConfirmation: false, restrictUpdate: false  })
              }
            }
          />
        }
        {
          showUpdateDuplicateTraineeConfirmation &&
          <ConfirmationModal
            show={ showUpdateDuplicateTraineeConfirmation }
            size = 'mini'
            title = 'Trainee Duplicate Update'
            message = {["Are you sure you want to update to a ", <strong>Duplicate Trainee</strong>,  "?", <br/>, "This is likely to cause confusion and take time to rectify."]}
            positiveLabel = 'Confirm'
            negativeLabel = 'Cancel'
            positiveButtonStyle = "red"
            negativeButtonStyle = "green"
            positiveCallback = { () => this.onUpdateDuplicateTrainee(this.props.trainee) }
            negativeCallback = { () => {
              this.refreshTraineesData()
              this.setState({ showUpdateDuplicateTraineeConfirmation: false, restrictUpdate: false  })
              }
            }
          />
        }
        {
          showUpdateTagsModal &&
          <UpdateTagsModal
            show={ showUpdateTagsModal }
            onClose={ () => this.setState({ showUpdateTagsModal: false }) }
            tags={this.state.tags}
            regions={this.state.regions}
            tagged_item={this.state.selectedRow}
            updateTags={this.updateTags}
          />
        }
        {
          showArchiveModal &&
          <ConfirmationModal
            show={ showArchiveModal }
            title = 'Archive Trainee'
            message = {`Are you sure you want to archive ${this.state.selectedRow.fullname}?`}
            positiveLabel = 'Archive'
            negativeLabel = 'Cancel'
            positiveCallback = { () => this.archiveTrainee(this.state.selectedRow.id) }
            negativeCallback = { () => this.setState({ showArchiveModal: false }) }
          />
        }
        {
          showUnarchiveModal &&
          <ConfirmationModal
            show={ showUnarchiveModal }
            title = 'Unarchive Trainee'
            message = {`Are you sure you want to unarchive ${this.state.selectedRow.fullname}?`}
            positiveLabel = 'Unarchive'
            negativeLabel = 'Cancel'
            positiveCallback = { () => this.unarchiveTrainee(this.state.selectedRow.id) }
            negativeCallback = { () => this.setState({ showUnarchiveModal: false }) }
          />
        }
        <div className='matrix-toolbar'>
          {
            !this.state.showMatrixView &&
            <Input
              placeholder='Search trainee'
              onChange={this.searchTrainee}
              value={this.state.filterOptions.search_term}
            />
          }
          <Dropdown
            placeholder='Select a tag'
            selection
            search
            options={this.state.allTags}
            onChange={this.onTagChange}
            value={this.state.filterOptions.tag_name}
          />
          <Dropdown
            placeholder='Select a role'
            selection
            search
            options={this.state.roleOptions}
            onChange={this.onRoleChange}
            value={this.state.roleFilter}
            loading={this.props.isLoadingRoles}
          />
          {
            !this.state.showMatrixView && (this.state.filterOptions.search_term || this.state.filterOptions.tag_name || this.state.roleFilter) &&
            <span className='anglo-links' onClick={this.clearFilters}>Clear Filters</span>
          }

          {
            this.state.filterOptions.tag_name.length !== 0 &&
            !this.state.showMatrixView && !this.state.isRegion &&
            <Button
              primary
              onClick={this.updateTag}
              name='edit'
            >
              <Icon name='pencil'/>Edit Team Tag
            </Button>
          }
          {
            !this.state.showMatrixView &&
            <Button
              primary
              onClick={this.createNewTag}
              name='new'
            >
              <Icon name='plus'/>Create New Team Tag
            </Button>
          }
          {
            (this.state.filterOptions.tag_name || this.state.roleFilter) && !this.state.showMatrixView && this.state.trainees.length > 0 &&
            <Button
              primary
              onClick={(evt)=>this.showMatrix(true)}
            >
              <Icon name='eye'/>Matrix View
            </Button>
          }
          {
            this.state.showMatrixView &&
            <Button
              primary
              onClick={(evt)=>this.showMatrix(false)}
            >
              <Icon name='eye'/>Team Tag View
            </Button>
          }
          {
            !this.state.showMatrixView &&
            <Button primary
              onClick={() => this.setState({ showAddTraineeForm: true }) }>
              <Icon name='user'/>Add Trainee
            </Button>
          }
          {
            this.state.showMatrixView &&
            <span>
              {
                !this.state.isExporting &&
                <span className='anglo-links' onClick={this.exportToExcel}>Export to Excel</span>
              }
              {
                this.state.isExporting &&
                <span className='exporting'><i className="loading circle notched icon"></i> Exporting...</span>
              }

            </span>

          }

          <span style={{marginLeft: 10}}>
            {
              !this.state.filterOptions.include_archived_trainees &&
              <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.toggleArchived}>Show Archived Trainees</span>
            }
            {
              this.state.filterOptions.include_archived_trainees &&
              <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.toggleArchived}>Hide Archived Trainees</span>
            }
          </span>

        </div>
        <div id='table_row_contextmenu'>
          <div as='a' onClick={ () => this.setState({ showAddTraineeForm: true }) } className="table_contextmenu">
            <Icon name='user' />Edit Trainee
          </div>
          {
            !hasInvalidDetails &&
            <div as='a' onClick={ () => this.setState({ showUpdateTagsModal: true }) } className="table_contextmenu">
              <Icon name='list' />Edit Tags
            </div>
          }
          <div as='a' onClick={ (evt) => this.showArchiveModal(evt) } className="table_contextmenu">
            <Icon name='file archive' />Archive Trainee
          </div>
        </div>
        <div id='archived_table_row_contextmenu' style={{pointerEvents: 'auto'}}>
          <div as='a' onClick={ (evt) => this.showUnarchiveModal(evt) } className="table_contextmenu">
            <Icon name='file archive' />Unarchive Trainee
          </div>
        </div>
        {
          !this.state.showMatrixView &&
          <div className='tables-row'>
            <div className='tables-row-full'>
              <div className='team-heading'>
                {
                  (this.state.filterOptions.tag_name.length > 0 ? (<span>Tag Name: <span className='team-name ui label'>{this.state.filterOptions.tag_name}</span></span>) : 'All Trainees')
                }
              </div>
              <InfiniteScroll
                className="trainees-table-scroll"
                dataLength={this.state.trainees.length}
                next={this.setNewPage}
                hasMore={true}
                scrollableTarget="trainees-table"
                height='calc(100vh - 140px)'
              >
                <TraineesTable
                  id='trainees-table'
                  trainees={this.state.trainees}
                  mode='view'
                  type='all'
                  tagName={this.state.filterOptions.tag_name}
                  regions={this.state.regions}
                  allTags={this.state.allTags}
                  updateTags={this.updateTags}
                  onTeamClick={this.onTagChange}
                  tags={this.state.tags}
                  render={this.state.renderTraineesTable}
                  setSelectedRow={this.setSelectedRow}
                  fetchingTrainees={!this.props.requestSuccess}
                  updateTraineeWithValidation={this.props.updateTraineeWithValidation}
                  defaultRoleOptions={this.props.defaultRoleOptions}
                />
                <ElementLoader loading={!this.props.requestSuccess} message="Loading trainees" />
              </InfiniteScroll>
            </div>
          </div>
        }

        {
          this.state.showMatrixView &&
          <MatrixTable
            trainingMatrix={ trainingMatrix }
            trainingModules={ trainingModules }
            updateTrainingRequirement={ this.updateTrainingRequirement }
            dataLoading={ this.state.loading }
            disabledCells={true}
          />
        }

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    trainee: state.trainees.trainee || state.trainingMatrix.trainee,
    trainees: state.trainees.trainees,
    requestSuccess: state.trainees.requestSuccess,
    requestType: state.trainees.requestType,
    duplicates: state.trainees.duplicates,
    duplicateTraineeMethod: state.trainees.duplicateTraineeMethod,
    showDuplicateTraineeWarning: state.trainees.showDuplicateTraineeWarning,
    tags: state.tags.tags,
    regions: state.tags.regions,
    allTags: state.tags.allTags,
    tagsRequestSuccess: state.tags.requestSuccess,
    tagsRequestType: state.tags.requestType,
    v2tags: state.v2tags,
    tag: state.tags.tag
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMatrix: (options) => {
      return dispatch(getTagMatrix(options))
    },
    addTrainee: (params) => {
      return dispatch(traineesActions.addTrainee(params))
    },
    addTraineeWithValidation: (params) => {
      return dispatch(traineesActions.addTraineeWithValidation(params))
    },
    addDuplicateTrainee: (params) => {
      return dispatch(traineesActions.addDuplicateTrainee(params))
    },
    getTrainees: (options) => {
      dispatch(traineesActions.getTrainees(options))
    },
    exportToExcel: (options) => {
      return exportToExcel(options)
    },
    updateTag: (options) => {
      return dispatch(updateTag(options))
    },
    updateTrainee: (params) => {
      return dispatch(traineesActions.updateTrainee(params))
    },
    updateTraineeWithValidation: (params) => {
      return dispatch(traineesActions.updateTraineeWithValidation(params))
    },
    updateDuplicateTrainee: (params) => {
      return dispatch(traineesActions.updateDuplicateTrainee(params))
    },
    archiveTrainee: (traineeId) => dispatch(traineesActions.archiveTrainee(traineeId)),
    unarchiveTrainee: (traineeId) => dispatch(traineesActions.unarchiveTrainee(traineeId)),
    getCategorizedTags: () => {
      return dispatch(getCategorizedTags())
    },
    createTag: (details) => {
      return dispatch(createTag(details))
    },
    createTrainingRequirement: (options) => {
      return dispatch(createTrainingRequirement(options))
    },
    updateTrainingRequirement: (options) => {
      return dispatch(updateTrainingRequirement(options))
    }
  }
}

const TraineesWithDefaultRoleOptions = withDefaultRoleOptions(Trainees)
export default connect(mapStateToProps, mapDispatchToProps)(TraineesWithDefaultRoleOptions);



// WEBPACK FOOTER //
// ./src/views/v2_trainees.js